module.exports = __webpack_public_path__ + "static/img/title-1.7168deaa.svg";